<template>
    <v-dialog width="70%" max-width="800" v-model="app.new_lead_dialog.show">
            <v-card>
                <v-card-title class="text-h6 primary darken-2 white--text font-weight-black">
                    NEW CONTACTS
                </v-card-title>

                <v-tabs v-model="app.new_lead_dialog.tab" grow background-color="primary">
                    <v-tab class="white--text">Text Entry</v-tab>
                    <v-tab class="white--text">Upload File</v-tab>
                </v-tabs>
                
                <v-card-text>
                    <v-tabs-items v-model="app.new_lead_dialog.tab">
                        <v-tab-item>
                            <div v-if="import_step == 'text_entry'">
                                <p class="pt-8 pb-4">You can enter one or more leads below, one-per line. You can manually type in the text or even copy-and-paste csv data.</p>
                                <v-textarea v-model="new_lead.post_title" label="Lead Text" rows="10" outlined></v-textarea>
                            </div>

                            <div v-else-if="import_step == 'fields'" class="pt-8">
                                <v-row>
                                    <v-col cols="2" class="text-center">Order</v-col>
                                    <v-col cols="3">Field</v-col>
                                    <v-col cols="7">Import To</v-col>
                                </v-row>
                                <v-divider class="mb-4"></v-divider>
                                <div style="max-height:50vh; overflow-y:auto; overflow-x:hidden;">
                                    <draggable v-model="import_leads_headers">
                                        <v-row v-for="(header, i) in import_leads_headers" :key="header.name">
                                            <v-col cols="2" class="text-center pt-8">
                                                <span>{{ i+1 }}</span>
                                            </v-col>
                                            <v-col cols="3" class="pt-8">
                                                {{header.name}}
                                            </v-col>
                                            <v-col cols="7">
                                                <!-- <v-switch v-model="header.import" dense hide-details></v-switch> -->
                                                <v-radio-group
                                                    v-model="header.import_to"
                                                    row
                                                    hide-details
                                                    dense
                                                >
                                                    <v-radio
                                                        label="Show in Title"
                                                        value="title"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="Do not import"
                                                        value="no_import"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                    </draggable>
                                </div>
                            </div>



                        </v-tab-item>
                        <v-tab-item>
                            <p class="pt-8 pb-4">Select a csv file to upload. All lines and fields will be imported. It's best if the contact's name is in the first columns of the file.</p>
                            <v-file-input v-model="csv_file" accept="text/csv"></v-file-input>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn text @click="import_step = 'text_entry'" v-if="import_step != 'text_entry'">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="app.new_lead_dialog.show = false" :disabled="saving_lead">
                        Close
                    </v-btn>
                    
                    <v-btn color="success" v-if="app.new_lead_dialog.tab == 0" @click="processLeadText">
                        Next
                    </v-btn>
                    <v-btn color="success" v-if="app.new_lead_dialog.tab == 0" @click="uploadCsvData">
                        Save CSV Text
                    </v-btn>
                    <v-btn color="success" v-if="app.new_lead_dialog.tab == 0" @click="createLead" :disabled="saving_lead" :loading="saving_lead">
                        Save
                    </v-btn>
                    <v-btn color="success" v-else @click="uploadCsv" :loading="saving_lead">
                        Upload
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import { useListsStore } from '../../stores/lists'
import { useAppStore } from '../../stores/app'
import { useLeadsStore } from '../../stores/leads'
import draggable from 'vuedraggable'

export default {
    name: 'DialogNewLeads',
    components: {
        draggable
    },
    data: () => ({
        leads: {leads: []},
        app: null,
        loading: false,
        showDialog: true,
        error: false,
        lists: null,
        new_lead: {
            ID: null,
            post_title: "",
            post_content: "",
        },
        csv_file: null,
        fileinput: "",
        saving_lead: false,
        leads_loading: false,
        import_leads_headers: null,
        import_leads_data: null,
        show_import_field_mapping: false,
        import_step: 'text_entry',
        import_to_options: [
            {
                text: 'Title', 
                value: 'title'
            },
            {
                text: 'Notes',
                value: 'notes'
            }
        ]
    }),
    created: function() {
        this.lists = useListsStore()
        this.app = useAppStore()
        this.leads = useLeadsStore()
    },
    methods: {
        createLead: function () {
            this.saving_lead = true
            let id = this.$route.params.id
            this.app.req.post(`lists/${id}/import_csv`, {
                data: this.new_lead.post_title
            }).then(data => {
                this.leads.leads = data
                this.leads_loading = false
                this.app.new_lead_dialog.show = false
                this.saving_lead = false
            })
        },
        uploadCsvData: function() {
            this.saving_lead = true
            let id = this.$route.params.id
            this.app.req.post(`lists/${id}/import_csv_text`, {
                headers: this.import_leads_headers,
                contacts: this.import_leads_data
            }).then(data => {
                this.leads.leads = data
                this.leads_loading = false
                this.app.new_lead_dialog.show = false
                this.saving_lead = false
            })
        },
        uploadCsv() {
            if (this.csv_file) {
                this.createInput(this.csv_file);
            }
            return

        },
        createInput(file) {
            this.saving_lead = true

            var g = this

            let promise = new Promise((resolve, reject) => {
                var reader = new FileReader();
                var vm = this;
                reader.onload = e => {
                    resolve((vm.fileinput = reader.result));
                };
                reader.readAsText(file);
            });

            promise.then(
                result => {
                    /* handle a successful result */
                    this.fileinput = this.fileinput.replace(/,/g, " ")

                    //perform upload
                    let id = this.$route.params.id
                    this.app.req.post(`lists/${id}/import_csv`, {
                        data: this.fileinput
                    }).then(data => {
                        g.leads.leads = data
                        g.leads_loading = false
                        g.app.new_lead_dialog.show = false
                        g.saving_lead = false
                    })

                },
                error => {
                    /* handle an error */
                    console.log(error);
                }
            );
        },
        processLeadText() {
            let text = this.new_lead.post_title
            this.csvJSON(text)
            this.import_step = "fields"
        },
        //var csv is the CSV file with headers
        csvJSON(csv){

            var lines=csv.split("\n");

            var result = [];
            
            let split = ','

            // remove first and last "
            if(lines[0][0] == '"') {
                lines[0] = lines[0].substr(1)
                lines[0] = lines[0].substr(0, lines[0].length - 1)
                split = '","'
            }

            var headers = lines[0].split(split)

            for(var i = 1; i < lines.length; i++) {

                var obj = {};
                if(lines[i][0] == '"') {
                    lines[i] = lines[i].substr(1)
                    lines[i] = lines[i].substr(0, lines[i].length - 1)
                    split = '","'
                }
                var currentline = lines[i].split(split);

                for(var j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j];
                }

                result.push(obj);

            }
            
            this.import_leads_headers = headers.map(header => {
                return {
                    name: header,
                    import: true,
                    import_to: 'notes'
                }
            })
            this.import_leads_data = result

            return result; //JSON
        }
    },
    watch: {
        tab: function(newV, oldV) {
            console.log("tab watch", newV, oldV)
        }
    }
}
</script>
